'use client'
import React, { useState } from 'react'
import Image from 'next/image'
import FrontSearchBar from '@components/FrontSearchBar'


const Hero = ({ dictionary, slogan, searchParams, lang, districtList }) => {


  return (
    <div className='w-full sm:h-[600px] h-[100vh] z-0 relative overflow-hidden'>
      <div className="h-full relative">
          <Image
              src={'/images/banner.avif'}
              fill={"true"}
              priority={"true"}
              style={{
                  objectFit: 'cover'
              }}
              alt="Banner Image"
          />
          <div className='absolute z-20 top-0 left-0 right-0 bottom-0 bg-black/30'></div>
      </div>
      <FrontSearchBar lang={lang} slogan={slogan} districtList={districtList} dictionary={dictionary} />
</div>
  )
}

export default Hero